import type { Condition, SearchQueryBody, SortDirection } from "@/types";

/**
 * Assembles a `SearchQueryBody` from already-translated `Condition`s.
 * The scope and filter conditions are joined under an outer `AND`.
 */
export function composeQueryBody(args: {
  scopeCondition: Condition | undefined;
  filterCondition: Condition | undefined;
  sort: { columnId: string; direction: "asc" | "desc" } | null | undefined;
}): SearchQueryBody {
  const { scopeCondition, filterCondition, sort } = args;
  const all: Condition[] = [
    ...(scopeCondition ? [scopeCondition] : []),
    ...(filterCondition ? [filterCondition] : []),
  ];
  let condition: Condition | undefined;
  if (all.length === 1) {
    condition = all[0];
  } else if (all.length > 1) {
    condition = { conditions: all, operator: "AND" };
  }

  return {
    ...(condition && { condition }),
    ...(sort && {
      sort_by: sort.columnId,
      sort_direction: sort.direction.toUpperCase() as SortDirection,
    }),
  };
}
